import { ViewDensity, ViewType } from "@common/types/views/views";
import {
    HistoryTaskUpdateColumn,
    HistoryTaskUpdateDetailsView,
} from "./historyTaskDetailsView";

export const createDefaultHistoryTaskUpdateView =
    (): HistoryTaskUpdateDetailsView => ({
        type: ViewType.HISTORY_TASK_UPDATE,
        columns: [
            { id: HistoryTaskUpdateColumn.TIME },
            { id: HistoryTaskUpdateColumn.TASK_TITLE },
            { id: HistoryTaskUpdateColumn.PREVIOUS },
            { id: HistoryTaskUpdateColumn.MODIFIED },
        ],
        filters: {},
        options: {
            selection: true,
            density: ViewDensity.MD,
        },
    });
